export function printFormatErrors(format, presets) {
    const errors = [];
    const number = (value, positive = false) => Number.isFinite(value) && (positive ? value > 0 : value >= 0);
    if (!format || !format.print_box || !Array.isArray(format.barcode_boxes)) return ['Ange ett giltigt tryckformat.'];
    if (format.source !== 'manual' && !presets.some((preset) => preset.id === format.source)) errors.push('Välj ett snabbval eller manuellt format.');
    if (!number(format.w, true) || !number(format.h, true)) errors.push('Sidans bredd och höjd måste vara större än noll.');
    const box = format.print_box;
    if (!['x1', 'x2', 'y1', 'y2'].every((key) => number(box[key]))
        || box.x1 >= box.x2 || box.y1 >= box.y2 || box.x2 > format.w || box.y2 > format.h) {
        errors.push('Tryckytan måste ha positiv bredd och höjd och rymmas inom sidan.');
    }
    if (format.barcode_boxes.length > 50) errors.push('Högst 50 streckkodsrutor kan anges.');
    format.barcode_boxes.forEach((barcode, index) => {
        const label = `Streckkodsruta ${index + 1}`;
        if (!number(barcode.x) || !number(barcode.y) || typeof barcode.barcode !== 'boolean') errors.push(`${label}: ange X, Y och om streckkod ska visas.`);
        const sizes = { w: 160, h: 10, barcode_h: 5 };
        Object.keys(sizes).forEach((key) => {
            if (barcode[key] !== undefined && barcode[key] !== null && barcode[key] !== '') {
                if (!number(barcode[key], true)) errors.push(`${label}: storlekarna måste vara större än noll.`);
                sizes[key] = barcode[key];
            }
        });
        if (barcode.x + sizes.w > format.w || barcode.y + sizes.h > format.h) errors.push(`${label} måste rymmas inom sidan (standardstorlek 160 × 10 mm).`);
        if (sizes.barcode_h > sizes.h) errors.push(`${label}: streckkodshöjden får inte överstiga rutans höjd.`);
    });
    return [...new Set(errors)];
}

export function cleanPrintFormat(format) {
    const copy = JSON.parse(JSON.stringify(format));
    copy.barcode_boxes.forEach((box) => {
        ['w', 'h', 'barcode_h'].forEach((key) => {
            if (box[key] === '' || box[key] === null) delete box[key];
        });
    });
    return copy;
}
